import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomePageModule)
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'supplydays/:auid/:cuid',
    loadChildren: () => import('./supplydays/supplydays.module').then(m => m.SupplydaysPageModule)
  },
  {
    path: 'supplydays/:auid/:cuid/:hidelogo/:startnextmonth',
    loadChildren: () => import('./supplydays/supplydays.module').then(m => m.SupplydaysPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, useHash: true })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
